var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[((_vm.name === 'TodayHot' || _vm.name=== 'FutureChance') && !_vm.hideNavigate)?_c('tab',{attrs:{"left-text":_vm.leftText,"right-text":_vm.rightText}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }